import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { CustomForm, CustomModal } from "../../components";
import {
  useAddUserMutation,
  useDeleteUserMutation,
  useFetchUsersQuery,
  useUpdateUserMutation,
} from "../../store/api/apiSlice";
import { Button as CustomBtn } from "../../ui";

const UserManagement = () => {
  const { data: usersData, isLoading, error, refetch } = useFetchUsersQuery({});

  const [addUser] = useAddUserMutation();
  const [updateUser] = useUpdateUserMutation();
  const [deleteUser] = useDeleteUserMutation();
  const [saveButton, setSaveButton] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedUsers, setSortedUsers] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [paid, setPaid] = useState(selectedUser?.isPaid || null);
  const itemsPerPage = 10;

  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [userEmails, setUserEmails] = useState([]);

  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const middleNameRef = useRef(null);
  const avatarNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const memberRef = useRef(null);
  const membershipNameRef = useRef(null);
  const isPaidRef = useRef(null);
  const ptgLevelRef = useRef(null);
  const schoolNameRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const zipRef = useRef(null);
  const referredByRef = useRef(null);
  const isAdminRef = useRef(null);

  const baseUrl = process.env.REACT_APP_SERVER_URL || "";
  const secretKey = process.env.REACT_APP_SECRET_KEY || "";
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    const limitedDigits = digits.slice(0, 10);

    const formatted = limitedDigits.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    );
    return formatted;
  };
  useEffect(() => {
    const fetchSchools = async () => {
      const xAuthToken =
        JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
      const headers = {
        "secret-key": secretKey,
        "x-auth-token": xAuthToken,
      };

      const response = await fetch(`${baseUrl}/api/university/get-all`, {
        method: "GET",
        headers,
      });
      const data = await response.json();
      setSchools(data.university || []);
    };

    const fetchUserEmails = async () => {
      const emails =
        usersData?.documents?.map((user) => ({
          value: user.email,
          label: user.email,
        })) || [];
      setUserEmails(emails);
    };

    fetchSchools();
    if (usersData) fetchUserEmails();
  }, [baseUrl, secretKey, usersData]);

  const openModal = (user = null) => {
    setSelectedUser(user);
    setIsCreating(!user);
    setModalOpen(true);
    setPaid(user?.isPaid || "");
    setSelectedSchool(user?.school_name || null);

    if (!user) {
      const newPassword = generateRandomPassword();
      setGeneratedPassword(newPassword);
    } else {
      setGeneratedPassword("");
    }
  };
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setSelectedUser(null);
    setIsCreating(false);
    setSelectedSchool(null);
    setGeneratedPassword("");
  };

  const generateRandomPassword = () => {
    return Math.random().toString(36).slice(-8);
  };
  const handleSubmit3 = async (id, is_active) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const updatedData = {
        columns: {
          is_active: is_active,
        },
      };

      const response = await fetch(
        `${baseUrl}/api/crud/${secretKey}/users/update/${id}`,
        {
          method: "PUT",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        }
      );

      if (response.ok) {
        const data = await response.json();

        toast.success("Status Updated");

        setSortedUsers((prevUsers) =>
          prevUsers.map((u) =>
            u._id === id ? { ...u, is_active: !is_active } : u
          )
        );
      } else {
        toast.error("Error while saving user");
      }
      refetch();
    } catch (error) {
      toast.error("Error while saving user");
    }
  };
  const handleSubmit2 = async (event, id, isPaid) => {
    event.stopPropagation();
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      const updatedData = {
        columns: {
          isPaid: isPaid,
        },
      };

      const response = await fetch(
        `${baseUrl}/api/crud/${secretKey}/users/update/${id}`,
        {
          method: "PUT",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedData),
        }
      );

      if (response.ok) {
        const data = await response.json();

        toast.success("Payment Status Updated");

        setSortedUsers((prevUsers) =>
          prevUsers.map((u) => (u._id === id ? { ...u, isPaid: !isPaid } : u))
        );
      } else {
        toast.error("Error while saving user");
      }
      refetch();
    } catch (error) {
      toast.error("Error while saving user");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaveButton(true);
    const userData = {
      firstName: firstNameRef.current?.value || "",
      middleName: middleNameRef.current?.value || "",
      lastName: lastNameRef.current?.value || "",
      avatarName: avatarNameRef.current?.value || "",
      email: emailRef.current?.value || "",
      isPaid: paid || Boolean,
      phone: phoneRef.current?.value || "",
      memberid: memberRef.current?.value || "",
      membershipName: membershipNameRef.current?.value || "",
      ptgLevel: ptgLevelRef.current?.value || "",
      school_name: selectedSchool?.value || "",
      address: {
        city: cityRef.current?.value || "",
        state: stateRef.current?.value || "",
        zip: zipRef.current?.value || "",
      },
      referredBy: referredByRef.current?.value || "",
      isAdmin: isAdminRef.current?.checked || true,
      password: isCreating ? generatedPassword : undefined,
    };

    try {
      if (isCreating) {
        await addUser(userData).unwrap();
        toast.success("User created successfully!");
      } else if (selectedUser && selectedUser._id) {
        const id = selectedUser._id;
        try {
          const token = JSON.parse(localStorage.getItem("token"));
          const xAuthToken = token ? token.token : null;

          const updatedData = {
            columns: {
              firstName: firstNameRef.current?.value || "",
              middleName: middleNameRef.current?.value || "",
              lastName: lastNameRef.current?.value || "",
              avatarName: avatarNameRef.current?.value || "",
              email: emailRef.current?.value || "",
              isPaid: paid || Boolean,
              phone: phoneRef.current?.value || "",
              memberid: memberRef.current?.value || "",
              membershipName: membershipNameRef.current?.value || "",
              ptgLevel: ptgLevelRef.current?.value || "",
              school_name: selectedSchool?.value || "",
              address: {
                city: cityRef.current?.value || "",
                state: stateRef.current?.value || "",
                zip: zipRef.current?.value || "",
              },
              referredBy: referredByRef.current?.value || "",
              isAdmin: isAdminRef.current?.checked || true,
              password: isCreating ? generatedPassword : undefined,
            },
          };

          const response = await fetch(
            `${baseUrl}/api/crud/${secretKey}/users/update/${id}`,
            {
              method: "PUT",
              headers: {
                "secret-key": secretKey,
                "x-auth-token": xAuthToken,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(updatedData),
            }
          );

          if (response.ok) {
            const data = await response.json();
            setSaveButton(false);

            toast.success("User updated successfully!");
            refetch();
            closeModal();
          } else {
            setSaveButton(false);
            toast.error("Error while saving user");
          }
        } catch (error) {
          setSaveButton(false);

          toast.error("Error while saving user");
        }
      }
      refetch();
      closeModal();
    } catch (error) {
      toast.error("Error while saving user");
    }
  };

  const schoolOptions = schools.map((school) => ({
    value: school.name,
    label: school.name,
  }));
  const filteredUsers =
    usersData?.documents?.filter((user) =>
      `${user.firstName} ${user.lastName} ${user.email}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    ) || [];

  const newSortOrder = filteredUsers?.sort((a, b) => {
    const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
    const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();

    return sortOrder === "asc"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  });
  const paginatedUsers = newSortOrder.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(newSortOrder.length / itemsPerPage);

  const openDetailsModal = async (userId) => {
    const xAuthToken =
      JSON.parse(localStorage.getItem("token") || "{}")?.token || "";
    const headers = {
      "secret-key": secretKey,
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/crud/${secretKey}/users/get-single/${userId}`,
        { headers }
      );

      if (response.ok) {
        const data = await response.json();
        setSelectedUser(data);
        setShowDetailsModal(true);
      } else {
        toast.error("Failed to fetch user details.");
      }
    } catch (error) {
      toast.error("Error fetching user details.");
    }
  };
  const handleRowClick = (e, userId) => {
    e.stopPropagation();
    openDetailsModal(userId);
  };

  const handleDelete = async (userId) => {
    try {
      await deleteUser(userId).unwrap();
      toast.success("User deleted successfully");
      refetch();
    } catch (error) {
      toast.error("Error deleting user");
    }
  };
  const handlePhoneChange = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatPhoneNumber(inputValue);
    phoneRef.current.value = formattedValue;
  };
  function safeParse(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      return [];
    }
  }
  const handleModalClick = (event) => {
    event.stopPropagation();
  };

  return (
    <>
      <div className="d-flex justify-content-between pb-4 gap-4 pt-4">
        <Button
          variant="outline-secondary"
          onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
        >
          {sortOrder === "asc" ? "Sort Descending" : "Sort Ascending"}
        </Button>
        <Form.Control
          type="text"
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <CustomBtn onClick={() => openModal()}>Create</CustomBtn>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Middle Initial</th>
              <th>Last Name</th>
              <th>Avatar Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>School</th>
              <th>member #</th>
              <th>Membership Name</th>
              <th>PTG Level</th>
              <th>Paid</th>
              <th>City</th>
              <th>State</th>
              <th>Zip</th>
              <th>Referred By</th>
              <th>Is Admin</th>
              <th>Payments</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedUsers.map((user) => (
              <tr
                key={user._id}
                onClick={(e) => handleRowClick(e, user._id)}
                style={{ cursor: "pointer" }}
              >
                <td>{user.firstName}</td>
                <td>{user.middleName}</td>
                <td>{user.lastName}</td>
                <td>{user.avatarName}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td>{user.school_name}</td>
                <td>{user.memberid}</td>
                <td>{user.membershipName}</td>
                <td>{user.ptgLevel}</td>
                <td>{user?.isPaid ? "Yes" : "No"}</td>
                <td>{user.address?.city || "N/A"}</td>
                <td>{user.address?.state || "N/A"}</td>
                <td>{user.address?.zip || "N/A"}</td>
                <td>{user.referredBy}</td>
                <td>{user.isAdmin ? "Yes" : "No"}</td>

                <td
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <select
                    value={user.isPaid ? "Paid" : "Unpaid"}
                    onChange={(event) => {
                      const selectedValue = event.target.value;
                      const newIsPaid = selectedValue === "Paid";
                      handleSubmit2(event, user._id, newIsPaid);
                    }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      cursor: "pointer",

                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "4px",
                    }}
                  >
                    <option value="Unpaid">Unpaid</option>
                    <option value="Paid">Paid</option>
                  </select>
                </td>
                <td
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  <select
                    value={user.is_active ? "Active" : "InActive"}
                    onChange={(event) => {
                      event.stopPropagation();
                      const selectedValue = event.target.value;
                      const newIsPaid = selectedValue === "Active";
                      handleSubmit3(user._id, newIsPaid);
                    }}
                    style={{
                      textDecoration: "none",
                      color: "black",
                      backgroundColor: "#f0f0f0",
                      cursor: "pointer",

                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "4px",
                    }}
                  >
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                  </select>
                </td>

                <td>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <img
                      className="Update-delete-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        openModal(user);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                      alt="create-new"
                    />

                    <img
                      className="Update-delete-icon"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDelete(user._id);
                      }}
                      width="30"
                      height="30"
                      src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                      alt="filled-trash"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
      {showDetailsModal && (
        <CustomModal
          isOpen={showDetailsModal}
          onClose={() => setShowDetailsModal(false)}
        >
          <div
            style={{
              maxWidth: "600px",
              padding: "20px",
              fontFamily: "Arial, sans-serif",
              color: "#333",
            }}
          >
            <h3
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              User Details
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px 20px",
                lineHeight: "1.6",
                fontSize: "0.95rem",
              }}
            >
              <p>
                <strong>First Name:</strong> {selectedUser?.firstName || "N/A"}
              </p>
              <p>
                <strong>Middle Initial:</strong>{" "}
                {selectedUser?.middleName || "N/A"}
              </p>
              <p>
                <strong>Last Name:</strong> {selectedUser?.lastName || "N/A"}
              </p>
              <p>
                <strong>Avatar Name:</strong>{" "}
                {selectedUser?.avatarName || "N/A"}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser?.email || "N/A"}
              </p>
              <p>
                <strong>Phone:</strong> {selectedUser?.phone || "N/A"}
              </p>
              <div>
                <strong>Favorite Sports:</strong>
                {selectedUser.favorite_sports?.[0] ? (
                  <table style={{ width: "100%" }}>
                    <tbody>
                    {selectedUser.favorite_sports && selectedUser.favorite_sports.length > 0 ? (
  selectedUser.favorite_sports.map((sport, index) => (
    <tr key={index}>
      <td>{sport.name || "No sports available"}</td>
      <td>:</td>
      <td>{sport.school || "No school available"}</td>
    </tr>
  ))
) : (
  <tr>
    <td colSpan="3">No favorite sports available.</td>
  </tr>
)}
                    </tbody>
                  </table>
                ) : (
                  <p>No favorite sports available</p>
                )}
              </div>
              <div>
                <strong>Favorite Athletes:</strong>
                {selectedUser.favorite_athletes?.[0] ? (
                  <table style={{ width: "100%" }}>
                    <tbody>
                      {JSON.parse(selectedUser.favorite_athletes[0]).map(
                        (athlete, index) => (
                          <tr key={index}>
                            <td>{athlete.name || "No athelete available"}</td>
                            <td>:</td>
                            <td>{athlete.school || "No school available"}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p>No favorite Athelete available</p>
                )}
              </div>

              <p>
                <strong>Member #:</strong> {selectedUser?.memberid || "N/A"}
              </p>
              <p>
                <strong>Membership:</strong>{" "}
                {selectedUser?.membershipName || "N/A"}
              </p>
              <p>
                <strong>School Name:</strong>{" "}
                {selectedUser?.school_name || "N/A"}
              </p>
              <p>
                <strong>Street Address:</strong>{" "}
                {selectedUser?.address?.streetAddress || "N/A"}
              </p>
              <p>
                <strong>City:</strong> {selectedUser?.address?.city || "N/A"}
              </p>
              <p>
                <strong>State:</strong> {selectedUser?.address?.state || "N/A"}
              </p>
              <p>
                <strong>Zip Code:</strong> {selectedUser?.address?.zip || "N/A"}
              </p>
              <p>
                <strong>PTG Level:</strong> {selectedUser?.ptgLevel || "N/A"}
              </p>
              <p>
                <strong>Paid:</strong> {selectedUser?.isPaid ? "Yes" : "No"}
              </p>
              <p>
                <strong>Referred By:</strong>{" "}
                {selectedUser?.referredBy || "N/A"}
              </p>
              <p>
                <strong>Is Game Verified:</strong>{" "}
                {selectedUser?.is_game_verified ? "Yes" : "No"}
              </p>
              <p>
                <strong>Is Verified:</strong>{" "}
                {selectedUser?.is_verified ? "Yes" : "No"}
              </p>
              <p>
                <strong>Is Active:</strong>{" "}
                {selectedUser?.is_active ? "Yes" : "No"}
              </p>
              <p>
                <strong>Is Admin:</strong>{" "}
                {selectedUser?.isAdmin ? "Yes" : "No"}
              </p>
              <p>
                <strong>Created At:</strong>{" "}
                {new Date(selectedUser?.createdAt).toLocaleString() || "N/A"}
              </p>
              <p>
                <strong>Updated At:</strong>{" "}
                {new Date(selectedUser?.updatedAt).toLocaleString() || "N/A"}
              </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            ></div>
          </div>
        </CustomModal>
      )}

      {isModalOpen && (
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <div
            onClick={handleModalClick}
            style={{
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "1rem",
            }}
          >
            <h3>{isCreating ? "Create New User" : "Update User"}</h3>
            <CustomForm
              onSubmit={handleSubmit}
              style={{ display: "grid", gap: "1rem" }}
            >
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="First Name"
                  ref={firstNameRef}
                  defaultValue={selectedUser?.firstName}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Control
                  placeholder="Middle Initial"
                  ref={middleNameRef}
                  defaultValue={selectedUser?.middleName}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
              </div>
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="Last Name"
                  ref={lastNameRef}
                  defaultValue={selectedUser?.lastName}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Control
                  placeholder="Avatar Name"
                  ref={avatarNameRef}
                  defaultValue={selectedUser?.avatarName}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
              </div>
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="Email"
                  ref={emailRef}
                  defaultValue={selectedUser?.email}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Control
                  placeholder="Phone"
                  ref={phoneRef}
                  defaultValue={selectedUser?.phone}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                  onChange={handlePhoneChange}
                />
              </div>
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="Member #"
                  ref={memberRef}
                  defaultValue={selectedUser?.memberid}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Select
                  placeholder="Is Active"
                  name="is_active"
                  value={paid}
                  onChange={(e) => setPaid(e.target.value)}
                >
                  <option value="">Select Is Paid</option>
                  <option value="true">True</option>
                  <option value="false">false</option>
                </Form.Select>
              </div>
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="Membership Name"
                  ref={membershipNameRef}
                  defaultValue={selectedUser?.membershipName}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Control
                  placeholder="PTG Level"
                  ref={ptgLevelRef}
                  defaultValue={selectedUser?.ptgLevel}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
              </div>
              {isCreating && (
                <Form.Group
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                  }}
                >
                  <Form.Label
                    style={{ fontWeight: "500", margin: 0, minWidth: "120px" }}
                  >
                    Generated Password
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      backgroundColor: "#f1f1f1",
                      padding: "0.75rem",
                      borderRadius: "5px",
                      flex: 1,
                    }}
                  >
                    <Form.Control
                      type="text"
                      value={generatedPassword}
                      readOnly
                      style={{
                        background: "transparent",
                        border: "none",
                        flex: 1,
                      }}
                    />
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() =>
                        navigator.clipboard.writeText(generatedPassword)
                      }
                      style={{ padding: "0.25rem 0.5rem" }}
                    >
                      Copy
                    </Button>
                  </div>
                </Form.Group>
              )}
              <div className="user_inputWraper">
                <Select
                  className="col-6"
                  options={schoolOptions}
                  placeholder="Select School"
                  value={selectedSchool}
                  onChange={(newValue) => setSelectedSchool(newValue)}
                  styles={{
                    container: (base) => ({ ...base, borderRadius: "5px" }),
                  }}
                />

                <Form.Control
                  placeholder="City"
                  ref={cityRef}
                  defaultValue={selectedUser?.address?.city}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
              </div>
              <div className="user_inputWraper">
                <Form.Control
                  placeholder="State"
                  ref={stateRef}
                  defaultValue={selectedUser?.address?.state}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
                <Form.Control
                  placeholder="Zip"
                  ref={zipRef}
                  defaultValue={selectedUser?.address?.zip}
                  style={{ padding: "0.75rem", borderRadius: "5px" }}
                />
              </div>
              <Select
                options={userEmails}
                placeholder="Select Referred By"
                ref={referredByRef}
                defaultValue={
                  selectedUser?.referredBy
                    ? {
                        value: selectedUser.referredBy,
                        label: selectedUser.referredBy,
                      }
                    : null
                }
                onChange={(newValue) =>
                  (referredByRef.current.value = newValue.value)
                }
                styles={{
                  container: (base) => ({ ...base, borderRadius: "5px" }),
                }}
              />

              <Form.Check
                label="is admin"
                ref={isAdminRef}
                defaultChecked={selectedUser?.isAdmin}
              />

              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="secondary" onClick={closeModal}>
                  Cancel
                </Button>
                <CustomBtn type="submit" loading={saveButton}>
                  Save
                </CustomBtn>
              </div>
            </CustomForm>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default UserManagement;
